import { SelectedPublishersContext } from "context/ViewContext/SelectedPublishersContext";
import { useProviderInitializedContext } from "./useProviderInitializedContext";

export const useSelectedPublishers = () => {
  return useProviderInitializedContext(SelectedPublishersContext);
};
